/**
 * External dependencies
 */
import React from "react";
import { connect } from "react-redux";
import { Box } from "@towersystems/towersystems-design-system";
import page from "page";
import { noop, map } from "lodash";

/**
 * Internal dependencies
 */
import { startEditing } from "state/ui/dashboard-form/actions";
import PageHeader from "layout/page-header";
import { isModalVisible } from "state/ui/selectors";
import { getName, getLayoutId } from "state/dashboard/selectors";
import { getAllLayouts } from "state/dashboard-layouts/selectors";
import DateRangePicker from "blocks/date-range-picker";
import { ButtonV2 } from "components/button-v2";
import { MdOutlineDashboardCustomize } from "react-icons/md";
import { TbChartBar } from "react-icons/tb";

/**
 * Style dependencies
 */
import "./styles.scss";

const DashboardHeader = ({
  newDashboardFocused = noop,
  activeDashboardId,
  dashboards = [],
  title,
  ...props
}) => {
  const headerItems =
    dashboards.length >= 1 &&
    map(dashboards, (dashboard) => {
      return {
        key: dashboard.id,
        label: dashboard.name,
        onClick: () => page(`/decks/${dashboard.id}`),
        active: activeDashboardId === dashboard.id,
      };
    });

  return (
    <React.Fragment>
      <PageHeader
        subtitle={<DateRangePicker />}
        actions={
          <Box display="flex">
            <div className="flex w-max gap-3">
              <ButtonV2
                isActive={newDashboardFocused}
                onClick={() => props.startEditing()}
                variant="primary"
                leftIcon={<MdOutlineDashboardCustomize size={20} />}
              >
                New deck
              </ButtonV2>
              <ButtonV2
                onClick={() => page("/reports/report-library")}
                secondary
                borderless
                leftIcon={<TbChartBar size={20} />}
              >
                Add view
              </ButtonV2>
            </div>
          </Box>
        }
        className="dashboard__header"
      ></PageHeader>
      <div className="dashboard__header-seperator"></div>
    </React.Fragment>
  );
};

export default connect(
  (state) => {
    let activeDashboardId = getLayoutId(state);
    let dashboards = getAllLayouts(state);

    return {
      newDashboardFocused: isModalVisible("EditDashboardPopover")(state),
      title: getName(state),
      dashboards,
      activeDashboardId,
    };
  },
  { startEditing }
)(DashboardHeader);
